import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import AnimatedBackground from "./components/animatedBackground";
import InstagramFeed from "./components/instagramFeed";
import Footer from "./components/footer";
import ImageCarousel from "./components/imageCarousel";

export default class Reasearch extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Research Sport Science";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />

				<TopBanner
					key="top_banner_key"
					bannerHeight="short"
					title="Research"
					images={["research/erik-professional-race-suit.jpg"]}
				/>
				{/* research-development-wind-tunnel.jpg */}
				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{ title: "Research", id: "research" },
						{ title: "3D Patterns", id: "3dpatterns" },
						{ title: "Wind Tunnel", id: "windtunnel" },
						{ title: "Material Science", id: "material" }
					]}
				/>
				{/* Research Section */}
				<div className="qs-b" ref="research">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Research</h1>
								</div>
							</div>
							<div className="col-12 col-md-6 content dark pt-0">
								<p className="lead">
									For Qwixskinz, research is a never ending pursuit of what is
									fastest.
								</p>
								<p>
									From fabric development that result in superior fabrics
									exclusive to Qwixskinz that allows us to reduce the
									aerodynamic drag of an athlete to state of the art wind tunnel
									testing facilities used to collect ever important data,
									Qwixskinz does it.
								</p>
								<p>
									We work independently or with teams that then have exclusive
									rights to the technology with uncover with them.
								</p>
								<p>
									Our collaborations with the best fabric developers is another
									key to our (&amp; your) success.
								</p>
								<p>
									With every season comes new developments &amp; improvements. We
									explore them all.
								</p>
								<p>2018 will be another big step in race suit research. </p>
							</div>
							<div className="col-12 col-md-6">
								<ImageCarousel
									images={[
										"images/research/wind-tunnel-race-speed-suit-testing.jpg",
										"images/research/qwixskinz-apline-skiing-wind-tunnel-race-suit-testing.jpg",
										"images/research/qwixskinz-wind-tunnel-research.jpg"
									]}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* 3D Scanning Section */}
				<div className="qs-b" ref="3dpatterns">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">3D Pattern Technology</h1>
								</div>
							</div>
							<div className="col-12 col-md-4">
								<ImageCarousel
									images={[
										"images/research/deanna-ace-alpine-race-suit.jpg",
										"images/research/qwixskinz-staff-material-science.jpg"
									]}
								/>
							</div>

							<div className="col-12 col-md-8 content dark pt-0">
								<p className="lead">
									2018 marks the year Qwixskinz takes a huge leap forward in the
									science &amp; technology of race suits!
								</p>
								<p className="lead">That time is now!</p>
								<p>
									Qwixskinz now has the world’s most innovative &amp; complete 3D
									patterning technology that allows us to take an athlete’s
									measurements from our newly expanded measuring protocol, build
									a custom virtual 3D model of each athlete, wrap our 3D race
									suit pattern onto the athlete &amp; with all Qwixskinz fabric
									stretch data incorporated into our software, be able to
									analyze where any potential fit, stretch or restricting issues
									may occur. Custom pattern adjusting is then applied. At
									Qwixskinz, we are taking this even farther with the ability to
									manipulate the virtual 3D model into sport-specific real race
									movements &amp; body positions to perfect the fit further.
								</p>
								<p>
									The best athletes in the world deserve the BEST race suits.
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Wind Tunnel Section */}
				<div className="qs-b" ref="windtunnel">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Wind Tunnel</h1>
								</div>
							</div>
							<div className="col-12 col-md-8 content dark pt-0">
								<p className="lead">NOT ALL WIND TUNNELS ARE CREATED EQUAL</p>

								<p>
									Qwixskinz has joined forces with ACE wind tunnel at UOIT to
									develop testing protocol that gives us extremely accurate
									information about drag coefficients.
								</p>
								<p>
									The ability to add environmental factors such as temperature &amp;
									humidity takes us to the front of the pack for wind tunnel
									testing. Sport specific data collection protocols also
									separate us from the rest. Ever important “blockage ratios”
									are factors in so many sports &amp; small wind tunnels cannot
									replicate race day conditions.
								</p>
								<p>
									Many companies make the claim about being “wind tunnel
									tested”, but at Qwixskinz just making a good “wind tunnel
									suit” is not acceptable. At Qwixskinz, we test &amp; refine our
									products to bring you the fastest RACE suit for race day.
								</p>
							</div>
							<div className="col-12 col-md-4">
								<img src="images/research/wind-tunnel-qwixskinz-science.jpg" />
							</div>
							<div className="col-12">
								<video
									className="mw-100 mt-4"
									poster="/images/research/videoPoster.jpg"
									controls>
									<source
										src="https://qwixskinz.s3.ca-central-1.amazonaws.com/QwixskinzWTVideo.mp4"
										type="video/mp4"
									/>
								</video>
							</div>
						</div>
					</div>
				</div>
				{/* Material Science Section */}
				<div className="qs-b" ref="material">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row">
							<div className="col content dark">
								<div className="section-title">
									<h1 className="title">Material Science</h1>

									<p className="lead">
										Technical fabrics improve &amp; change constantly. At Qwixskinz,
										we are always studying &amp; pushing the latest developments
										that allow us to manipulate air flow, reduce drag, increase
										muscle compression &amp; activation. Anything that is required
										by each individual sport.
									</p>
									<p>
										Working together with the world’s leading aerodynamic fabric
										mills, Qwixskinz is researching, developing &amp; testing all
										fabric options to stay at the forefront of the industry.
										Utilizing climatic wind tunnel testing, provides us with
										actual race day environmental factors as well as aerodynamic
										data that is used in the all important fabric research.
										These collaborations have resulted in superior fabrics, some
										exclusive to Qwixskinz, that are used in our race suits
										today. The newly added 3D simulation technology enables
										testing of stretch, warp &amp; weft for each fabric, giving us
										insight into not only the best choices for each sport but
										also the next step in fabric characteristics we target to
										develop.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
